import { render, staticRenderFns } from "./IntegrationPlugin.vue?vue&type=template&id=cd135170&"
import script from "./IntegrationPlugin.vue?vue&type=script&lang=js&"
export * from "./IntegrationPlugin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports